import { render, staticRenderFns } from "./selectProductDialog.vue?vue&type=template&id=15c31cb0&scoped=true&"
import script from "./selectProductDialog.vue?vue&type=script&lang=js&"
export * from "./selectProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./selectProductDialog.vue?vue&type=style&index=0&id=15c31cb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c31cb0",
  null
  
)

export default component.exports